import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class ApPersistenceService {
    public getLocal(key: string, property: string): any {
        return this.getFromStorage(window.localStorage, key)[property];
    }

    public setLocal(key: string, property: string, value: any): void {
        const data: any = this.getFromStorage(window.localStorage, key);
        data[property] = value;
        window.localStorage.setItem(key, JSON.stringify(data));
    }

    public clearLocal(key: string): void {
        window.localStorage.removeItem(key);
    }

    public getSession(key: string, property: string): any {
        return this.getFromStorage(window.sessionStorage, key)[property];
    }

    public setSession(key: string, property: string, value: any): void {
        const data: any = this.getFromStorage(window.sessionStorage, key);
        data[property] = value;
        window.sessionStorage.setItem(key, JSON.stringify(data));
    }

    public clearSession(key: string): void {
        window.sessionStorage.removeItem(key);
    }

    private getFromStorage(storage: Storage, key: string): any {
        const item = storage.getItem(key);
        if (!item) {
            return {};
        }
        try {
            return JSON.parse(item);
        } catch (Error) {
            return {};
        }
    }
}
